export const homeObjOne = {
    id: 'awards',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'Awards That We\'ve Won',
    description: 'Check out some of the KAB awards that TMN has won recently.',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/svg-1.svg').default,
    alt: 'Cartoon Videographer',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'roles',
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'How You Can Be Involved',
    description: 'Take a look at some of the roles that we have at TMN.',
    buttonLabel: 'More Info',
    imgStart: true,
    img: require('../../images/svg-2.svg').default,
    alt: 'Cartoon Camera Operator',
    dark: false,
    primary: false,
    darkText: true
};

export const homeObjThree = {
    id: 'equipment',
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'Equipment',
    description: 'View all the industry standard equipment that you\'ll get to use.',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/Test.jpg').default,
    alt: 'Tricaster',
    dark: true,
    primary: true,
    darkText: true
};

export const homeObjFour = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Director',
    headline: 'Justin Davis',
    description: '"I\'ve enjoyed working at TMN immensely for the past three years of my college career. I\'ve always said that graduating is a bittersweet moment because while I\'m happy to graduate, I know that TMN will get better next year and even better after that and there\'s a large part of me that is sad I won\'t be there for it. I am proud however at having a chance to be apart of TMN for as long as I did."',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/JT.jpg').default,
    alt: 'JT',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjFive = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Replay Operator',
    headline: 'Amy Williams',
    description: '"TMN has been a wonderful job! I\'ve loved the new friends I\'ve made as well as being able to get paid for doing something fun and unique like broadcasting all different types of sports."',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/student.jpg').default,
    alt: 'student',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjSix = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'Camera Operator',
    description: 'Camera Operators are the lifeblood of Tiger Media Network\'s sports broadcasts. Without them, we would obviously have nothing to show. As the title implies, they operate all of our cameras during productions. This can be anywhere from a single camera production to having upwards of eight or ten cameras depending on the situation.',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/CameraOp.jpg').default,
    alt: 'Camera Operator',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjSeven = {
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'On-Air Talent',
    description: 'On-Air Talent are the people you see on the broadcasts. For news, that would be the anchors and the reporters. For sports, it\'s the play-by-play and color commentator. These positions provide analysis on exactly what the viewers are looking at, giving supplementary information.',
    buttonLabel: 'More Info',
    imgStart: true,
    img: require('../../images/Talent.jpg').default,
    alt: 'On-Air Talent',
    dark: true,
    primary: true,
    darkText: true
};
export const homeObjEight = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'Replay Operator',
    description: 'The Replay Operator is the person who makes the replays that are shown on both the sports broadcast as well as on the video boards at both Lewis Field Stadium and Gross Memorial Coliseum. This role is fast paced and requires a lot of focus, but the outcome is a pivotal addition to any sports broadcast.',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/Replay.png').default,
    alt: 'Replay Operator',
    dark: true,
    primary: true,
    darkText: false
};
export const homeObjNine = {
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'Technical Director',
    description: 'The Technical Director is the one who works with the video switcher. The Technical Director will listen to the director and put whatever they say on the screen. Everything that shows up on the broadcast is there because the Technical Director put it there. From graphics, to specific cameras, and even commercials.',
    buttonLabel: 'More Info',
    imgStart: true,
    img: require('../../images/TechDirector.jpg').default,
    alt: 'Technical Director',
    dark: true,
    primary: true,
    darkText: true
};
export const homeObjTen = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: 'Director',
    description: 'The Director is the one who takes all the pieces (cameras, on-air talent, replays, and graphics) and puts it together to create the final product that goes live. The Director is in the ear of every other role asking for specific camera shots, letting the on-air talent know when they are live, asking for graphics to be put up, etc.',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/Director.jpg').default,
    alt: 'Director',
    dark: true,
    primary: true,
    darkText: false
};
export const homeObjEleven = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Tiger Media Network',
    headline: '2022 KAB Awards',
    description: 'Undergrad Radio',
    description2: 'Undergrad TV',
    lineOne: 'DJ Personality OR News Anchor - 2nd Place',
    lineTwo: 'Enterprise News Package - 1st Place',
    lineThree: 'Best Social Media - 2nd Place',
    lineFour: 'Sports Play by Play - 1st Place',
    lineFive: 'Station Website - 1st Place',
    lineSix: 'Complete News Feature - Honorable Mention',
    lineSeven: 'Complete Sports Feature - 1st Place',
    lineEight: 'Enterprise News Package - 2nd Place',
    lineNine: 'Public Affairs Program (15-60 min max) - 2nd Place & Honorable Mention',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/KAB.jpg').default,
    alt: 'Kansas Association of Broadcasters',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwelve = {
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'On-Air Talent',
    headline: 'John Smith',
    description: '"TMN has allowed me to work in an environment that will be comparable to what I\'ll see in the real world. It\'s allowed me to gain experience at the job I want to do after I graduate college and even helped me connect with a few people in the industry!"',
    buttonLabel: 'More Info',
    imgStart: false,
    img: require('../../images/student.jpg').default,
    alt: 'student',
    dark: true,
    primary: true,
    darkText: true
};
